import { ValidateResultsState, Consumer } from './types';

/**
 * Method: isConsumerVerified
 * Description: isConsumerVerified is a utility function that checks if a consumer is verified. Also returns true if nothing to verify
 */
export function isConsumerVerified(consumer: Consumer, validated: ValidateResultsState): boolean {
  const email = consumer?.emails?.[0]?.value?.toUpperCase();
  const phone = consumer?.phones?.[0]?.value;
  // If no email or phone, return true
  if (!phone && !email) return true;
  const results = validated?.results;
  return !!(
    (email && results && results[email]?.verifyCode) ||
    (phone && results && results[phone]?.verifyCode)
  );
}

export function getProfileVerifyValues(
  consumer: Consumer,
  validated: ValidateResultsState
): {
  profileVerifyValue: string;
  profileVerifyCode: string;
  profileVerifyType: 'phone' | 'email';
} {
  const consumerEmail = consumer?.emails?.[0]?.value?.toUpperCase();
  const consumerPhone = consumer?.phones?.[0]?.value;

  let profileVerifyValue = '';
  let profileVerifyCode = '';
  let profileVerifyType: 'phone' | 'email' = 'email';
  if (validated?.results?.[consumerEmail]?.verifyCode) {
    profileVerifyCode = validated?.results?.[consumerEmail]?.verifyCode;
    profileVerifyValue = consumerEmail;
  } else if (validated?.results?.[consumerPhone]?.verifyCode) {
    profileVerifyCode = validated?.results?.[consumerPhone]?.verifyCode;
    profileVerifyValue = consumerPhone;
    profileVerifyType = 'phone';
  }
  return { profileVerifyValue, profileVerifyCode, profileVerifyType };
}
